var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"client-container"},[_c('MenuBar'),_c('div',{staticClass:"content"},[_c('Login'),_c('Main')],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }